import { render, staticRenderFns } from "./SummaryStatusActionsDetails.vue?vue&type=template&id=644594a7&"
import script from "./SummaryStatusActionsDetails.vue?vue&type=script&lang=js&"
export * from "./SummaryStatusActionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports